// Internals
import { styled } from '../../../stitches.config'

export const ApplePayContainer = styled('div', {
  ApplePayButtonStyle: 'black',
  ApplePayButtonType: 'plain',
  cursor: 'pointer',
  display: 'inline-block',
  height: 48,
  WebkitAppearance: '-apple-pay-button',
  width: '100%',
})
